module.exports = __webpack_public_path__ + "static/media/start_point_500.eb62766a.png";